<template>
    <kgr-form-scaffold
        :pending="pending"
        :save-button-disabled="!newFeeValid"
        with-back-button
        with-primary-buttons
        @primaryBtnClicked="updateFee"
        @backBtnClicked="redirectToOverview"
    >
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Beitrag bearbeiten') }}
        </h3>
        <kgr-club-fee-form
            v-if="newFee"
            edit-mode
            :club-id="clubId"
            :club-fee-edit="newFee"
            :error="error"
            @update="syncFee($event)"
        />
    </kgr-form-scaffold>
</template>

<script>
import ClubFeeForm from '../../../components/club/accounting/ClubFeeForm.vue';
import ClubFeeRepository from '../../../js/repository/ClubFeeRepository.js';
import Error from '../../../js/model/Error.js';
import FormScaffold from '../../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-club-fee-form': ClubFeeForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        clubFeeId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            newFee: null,
        };
    },
    computed: {
        newFeeValid() {
            return this.newFee?.category !== null && this.newFee?.name !== '';
        },
    },
    created() {
        this.loadClubFee();
    },
    methods: {
        updateFee() {
            const fee = this.newFee;
            const payload = {
                name: fee.name,
                note: fee.note ?? '',
                feeCategoryId: fee.category.id,
                departmentId: fee.department?.id,
                clubCostCenterId: fee.clubCostCenter ? fee.clubCostCenter.id : null,
                impersonalAccountId: fee.impersonalAccount ? fee.impersonalAccount.id : null,
                invoiceTemplateType: fee.invoiceTemplateType,
            };
            if (fee.paymentApproach !== 'undefined') {
                payload.paymentApproach = fee.paymentApproach;
            }
            if (fee.paymentInterval.type !== '') {
                payload.paymentInterval = {
                    type: fee.paymentInterval.type,
                };
                switch (fee.paymentInterval.type) {
                    case 'monthly':
                        payload.paymentInterval.day = fee.paymentInterval.monthly.day.value;
                        break;

                    case 'monthlyEnd':
                        payload.paymentInterval.offset = fee.paymentInterval.monthlyEnd.offset.value;
                        break;

                    case 'quarterly':
                        payload.paymentInterval.offsetDay = fee.paymentInterval.quarterly.offsetDay.value;
                        payload.paymentInterval.offsetMonth = fee.paymentInterval.quarterly.offsetMonth.value;
                        break;

                    case 'halfYearly':
                        payload.paymentInterval.offsetDay = fee.paymentInterval.halfYearly.offsetDay.value;
                        payload.paymentInterval.offsetMonth = fee.paymentInterval.halfYearly.offsetMonth.value;
                        break;

                    case 'yearly':
                        payload.paymentInterval.day = fee.paymentInterval.yearly.day.value;
                        payload.paymentInterval.month = fee.paymentInterval.yearly.month.value;
                        break;

                    default:
                        throw new Error(`Payment interval "${fee.paymentInterval.type}" does not exist.`);
                }
            }
            this.loading = true;
            ClubFeeRepository.update(fee.id, payload)
                .then(() => this.redirectToOverview())
                .catch(() => this.$notify.error('saveChanges.error'))
                .finally(() => this.loading = false);
        },
        syncFee(fee) {
            this.newFee = fee;
        },
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/accounting/fee-management`;
        },
        loadClubFee() {
            this.pending = true;
            ClubFeeRepository.findByIdForAccounting(this.clubFeeId)
                .then((response) => this.newFee = response)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pending = false);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
